import { Course } from "@components/C282_Electives/ElectiveItem";
import { fetchApi } from "@utilities/fetchApi";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const C282_Electives = dynamic(
  () => import("@components/C282_Electives/C282_Electives")
);
export interface ProgrammeCoursesProps {
  courseType?: string;
  columns?: string;
  singleDisplay?: boolean;
  defaultOpen?: boolean;
  programmeTitle?: string;
}

const ProgrammeCourses = (props: { content: ProgrammeCoursesProps }) => {
  const { content } = props;
  const { courseType, programmeTitle, columns = 4 } = content;
  const [courses, setCourses] = useState<Array<Course>>([]);

  useEffect(() => {
    const getData = async () => {
      const data: Course[] = await fetchApi("/api/getProgrammeCourses", {
        programmeTitle,
        courseType,
      });

      setCourses(data);
    };

    getData();
  }, []);

  // @ts-expect-error type mistmatch
  return <C282_Electives courses={courses} columns={columns} {...content} />;
};

export default ProgrammeCourses;
